// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ApproveDenyButtonGroup from './approve-deny-button-group';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../../shared/services/security';

const SecureApproveDenyButtonGroup = (props, context) =>
    hasAccess(context.security, props.securityModule, props.securityFeature) &&
        <ApproveDenyButtonGroup
            isApproveDisabled={props.isApproveDisabled}
            isDenyDisabled={props.isDenyDisabled}
            isReturnDisabled={props.isReturnDisabled}
            isShowReturnButton={props.isShowReturnButton}
            onApprove={props.onApprove}
            onDeny={props.onDeny}
            onReturn={props.onReturn}
        />;

SecureApproveDenyButtonGroup.displayName = 'SecureApproveDenyButtonGroup';
SecureApproveDenyButtonGroup.propTypes = {
    isApproveDisabled: PropTypes.bool,
    isDenyDisabled: PropTypes.bool,
    isReturnDisabled: PropTypes.bool,
    onApprove: PropTypes.func.isRequired,
    onDeny: PropTypes.func.isRequired,
    onReturn: PropTypes.func.isRequired,
    securityFeature: PropTypes.string,
    securityModule: PropTypes.string.isRequired
};
SecureApproveDenyButtonGroup.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};
SecureApproveDenyButtonGroup.defaultProps = {
    isShowReturnButton: false
};
export default SecureApproveDenyButtonGroup;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/secure-approve-deny-button-group.js